import React from "react";
import {StyledBoxRow,} from "@/shared/StyledComponents";
import {Button} from "@mui/material";
import {BaseApp} from "@/shared/BaseApp";
import {SendWhatsAppDialog} from "@/libwyze-shared/components/SendWhatsAppDialog";
import {BaseMessageCampaignFragment} from "../BaseMessageCampaignFragment";
import {BaseWhatsAppCampaignCustomizeOptions} from "@/vantage-shared/types";

export type WhatsApp = {
  body: string,
}

export abstract class BaseWhatsAppCampaignFragment<OPTIONS extends BaseWhatsAppCampaignCustomizeOptions> extends BaseMessageCampaignFragment<WhatsApp, OPTIONS> {

  protected renderTestButtons(): React.ReactElement {
    return <StyledBoxRow>
      <Button
        onClick={() => {
          const id = BaseApp.CONTEXT.showDialog(
            null,
            () => <SendWhatsAppDialog
              templateId={this.campaignConfig.messaging.templateId}
              templateVariables={this.campaignConfig.messaging.templateVariables}
              onSent={() => BaseApp.CONTEXT.hideDialog(id)}/>
          );
        }}
        variant={"outlined"}>
        Send test WhatsApp
      </Button>
    </StyledBoxRow>;
  }
}